export function operacaoLiberacaoRemotaConsultaInRequest(params = {}) {
  return {
    type:
      '@operacaoliberacaoremotaconsulta/OPERACAOLIBERACAOREMOTACONSULTA_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoLiberacaoRemotaConsulta(movi_codigo) {
  return {
    type:
      '@operacaoliberacaoremotaconsulta/FIND_OPERACAOLIBERACAOREMOTACONSULTA',
    payload: { movi_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoliberacaoremotaconsulta/FAILED_REQUEST',
  };
}

export function deleteOperacaoLiberacaoRemotaConsulta(movi_codigo, params) {
  return {
    type:
      '@operacaoliberacaoremotaconsulta/DELETE_OPERACAOLIBERACAOREMOTACONSULTA',
    payload: { movi_codigo, params },
  };
}

export function updateOperacaoLiberacaoRemotaConsulta(
  operacaoliberacaoremotaconsulta,
  params
) {
  return {
    type:
      '@operacaoliberacaoremotaconsulta/UPDATE_OPERACAOLIBERACAOREMOTACONSULTAA',
    payload: { operacaoliberacaoremotaconsulta, params },
  };
}

export function storeOperacaoLiberacaoRemotaConsulta(
  operacaoliberacaoremotaconsulta,
  params
) {
  return {
    type:
      '@operacaoliberacaoremotaconsulta/STORE_OPERACAOLIBERACAOREMOTACONSULTA',
    payload: { operacaoliberacaoremotaconsulta, params },
  };
}

export function successInRequest(
  operacaoliberacaoremotaconsulta,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoliberacaoremotaconsulta/SUCCESS_IN_REQUEST',
    payload: {
      operacaoliberacaoremotaconsulta,
      page,
      pageSize,
      totalCount,
      totalPages,
    },
  };
}

export function successRequest(operacaoliberacaoremotaconsulta) {
  return {
    type: '@operacaoliberacaoremotaconsulta/SUCCESS_REQUEST',
    payload: { operacaoliberacaoremotaconsulta },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoliberacaoremotaconsulta/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoliberacaoremotaconsulta/RECORD_FILTERING',
    payload: { params },
  };
}
